<template>
<div class="form-builder-section" :class="{active: isActive}" >
	<div class="field-controls">
		<i class="handle-section icon-button fa fa-fw fa-sort" title="Re-order"></i>

		<i class="icon-button fa fa-fw" :class="{'fa-caret-down' : collapsed, 'fa-caret-up': !collapsed}" v-on:click="collapsed = !collapsed" title="Collapse/Expand"></i>

		<i v-on:click="$emit('activate')" class="icon-button fa fa-fw fa-bullseye" :class="{'text-success':isActive}" title="Select section"></i>

		<i class="fa fa-trash icon-button" style="margin-left: auto;" v-on:click="$emit('trash')" title="Delete section"></i>
	</div>

	<field label="Section Heading"
		col-class="col-md-4"
		v-model="sectionHeading"
		v-on:change="emitInput">
	</field>

	<draggable v-model="fields" handle=".handle-field" v-on:end="emitInput">
		<form-builder-field v-if="!collapsed" v-for="(field,index) in fields"
			:key="sectionHeading+'_'+index"
			v-on:trash="trashField(index)"
			v-on:input="emitInput"
			:job-personnel-roles="jobPersonnelRoles"
			:employees="employees"
			v-model="fields[index]">
		</form-builder-field>
	</draggable>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormBuilderField from "@/components/FormBuilderField"
import draggable from 'vuedraggable'

export default {
	components: {
		Field,
		FormBuilderField,
		draggable
	},
	props: ["value","isActive","jobPersonnelRoles","employees"],
	data() {
		return {
			sectionHeading: "",
			fields: [],
			collapsed: true
		}
	},
	watch: {
		value() {
			this.setData()
		},
		isActive() {
			if (this.isActive)
				this.collapsed = false
			else
				this.collapsed = true
		}
	},
	methods: {
		trashField(index) {
			this.fields.splice(index,1)

			this.emitInput()
		},
		setData() {
			this.sectionHeading = this.value.sectionHeading
			this.fields = this.value.fields
		},
		headingChange() {
			
		},
		emitInput() {
			let vm = this

			this.$nextTick(() => {
				vm.$emit("input",{
					sectionHeading: vm.sectionHeading,
					fields: vm.fields
				})
			})
		}
	},
	created() {
		this.setData()

		if (this.isActive)
			this.collapsed = false
	}
}
</script>

<style type="text/css" scoped>
	.form-builder-section {
		padding: 10px;
		background-color: #EAE9E7;
		border: 1px dotted #808080;
		margin-bottom: 10px;
	}

	.form-builder-section.active {
		background-color: #e8e7c8;
	}

	.field-controls {
		display: flex;
		margin-bottom: 10px;
	}

</style>